import { defineStore } from 'pinia';

interface toast {
    message: string,
    toastType?: string,
    disappear?:Boolean
}

interface toasts {
    toasts: toast[],
    errorMessage:String
}
export const useToastStore = defineStore({
  id: 'toastStore',
  state: (): toasts => ({
    toasts: [],
    errorMessage: ''
  }),
  getters: {
    getErrorMessage: (state) => () => {
			return state.errorMessage;
		},
  },
  actions: {
    addToast(toast:toast) {
      toast.disappear = toast.disappear == undefined? true: toast.disappear;
      toast.toastType =  toast.toastType == undefined? 'default':toast.toastType;
        this.toasts.push(toast);
      },
    clearToast(msg:string) {
      const index = this.toasts.findIndex((toast) => toast.message === msg); // find toast
      this.toasts.splice(index, 1); // remove toast from array
    },
    clearAllToast() { 
      this.toasts = []; 
    }
  }
})
